/* tslint:disable:jsx-no-lambda WI:47647 */
import { observer } from 'mobx-react';
import * as React from 'react';
import { ControlIcons } from 'owa-control-icons';
import { IconButton } from 'office-ui-fabric-react/lib/Button';
const styles = require('./FeatureExample.scss');
import { lightable, LightningProps, lighted } from 'owa-lightning-v2';

export interface FeatureExampleProps extends LightningProps {
    gif: string;
    gifOverlayText: string;
}

@observer
@lightable
export default class FeatureExample extends React.Component<FeatureExampleProps, {}> {
    render() {
        return (
            <div className={styles.gifContainer}>
                <div className={styles.gifOverlayText}>{this.props.gifOverlayText}</div>
                <img className={styles.gif} src={this.props.gif} />
                <IconButton
                    className={styles.cancel}
                    iconProps={{
                        iconName: ControlIcons.Cancel,
                        styles: {
                            root: styles.cancelIcon,
                        },
                    }}
                    onClick={() => lighted(this.props.lid)}
                />
            </div>
        );
    }
}
